import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publishersManageService } from '../api/publishersManageService';
import type {
  BulkDeletePublishersDto,
  BulkPublisherOperationResultDto,
  BulkPublisherQuotaUpdateDto,
  BulkSetPublisherActiveDto,
} from '../types/managePublishers';

export function useBulkPublisherActions() {
  const qc = useQueryClient();

  const invalidate = () => qc.invalidateQueries({ queryKey: ['manage-publishers'] });

  const bulkSetActive = useMutation<BulkPublisherOperationResultDto, Error, BulkSetPublisherActiveDto>({
    mutationFn: (dto) => publishersManageService.bulkSetActive(dto),
    onSuccess: invalidate,
  });

  const bulkQuotas = useMutation<BulkPublisherOperationResultDto, Error, BulkPublisherQuotaUpdateDto>({
    mutationFn: (dto) => publishersManageService.bulkQuotas(dto),
    onSuccess: invalidate,
  });

  const bulkDelete = useMutation<BulkPublisherOperationResultDto, Error, BulkDeletePublishersDto>({
    mutationFn: (dto) => publishersManageService.bulkDelete(dto),
    onSuccess: invalidate,
  });

  return { bulkSetActive, bulkQuotas, bulkDelete };
}
